Ext.define('SA.Observable', {
    singleton: true,

    apply(target) {
        var observable = new Ext.util.Observable(),
            methods = ['on', 'un', 'mon', 'mun', 'fireEvent'],
            addMethod = name => Reflect.set(target, name, (...args) => observable[name](...args));

        methods.forEach(name => addMethod(name));
    }
});